import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { API_URL } from '../services/api-config'

// Displays shipment details in a simple scrollable table inside pop-details-container
const Shipmentdetails = ({ caseDetailsInfo }) => {
  const casenumber = caseDetailsInfo?.casenumber

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // Fetch shipments by case number
  useEffect(() => {
    if (!casenumber) return
    setLoading(true)
    setError(null)

    axios
      .get(`${API_URL}/shipment-by-case/${encodeURIComponent(casenumber)}`)
      .then((res) => {
        const data = res?.data?.body?.data ?? []
        setRows(Array.isArray(data) ? data : [])
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err?.message || 'Failed to load shipment data'
        setError(msg)
        setRows([])
      })
      .finally(() => setLoading(false))
  }, [casenumber])

  // Define table columns (keys must match row object fields)
  const columns = [
    { id: 'blnumber', label: 'BL Number' },
    { id: 'payeescvid', label: 'Payee SCVID' },
    { id: 'collectionbusinessunit', label: 'Collection Business Unit' },
    { id: 'payeecmdcode', label: 'Payee CMD Code' },
    { id: 'apistatus', label: 'API Status' },
    { id: 'paymentterm', label: 'Payment Term' },
    { id: 'porcountry', label: 'POR Country' },
    { id: 'podcountry', label: 'POD Country' },
  ]

  const safe = (row, key) => {
    const val = row && row[key]
    return val !== undefined && val !== null && val !== '' ? val : '-'
  }
  // Dynamic widths: make current columns equally occupy full width; add horizontal scroll if more columns later
  const colWidthPct = `${(100 / columns.length).toFixed(2)}%`
  const minTableWidth = `${columns.length * 160}px` // ensure readable min width -> triggers scroll when too many columns

  return (
    <div>
      <div className="pop-details-container">
        <div className="pop-header">
          <p className="header-text">{`Shipment Details${casenumber ? ` — Case ${casenumber}` : ''}`}</p>
        </div>
        <hr className="divider" />

        <div className="details-section">
          <div
            className="simple-table-wrapper"
            style={{ maxWidth: '100%', overflowX: 'auto' }}
          >
            <table
              className="simple-table"
              style={{ width: '100%', minWidth: minTableWidth, tableLayout: 'fixed', borderCollapse: 'collapse' }}
            >
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.id}
                      style={{
                        width: colWidthPct,
                        textAlign: 'left',
                        padding: '8px 12px',
                        background: '#f2f4f7',
                        borderBottom: '1px solid #e0e0e0',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      title={col.label}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={columns.length} style={{ padding: '12px', textAlign: 'center' }}>
                      Loading shipments...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={columns.length} style={{ padding: '12px', textAlign: 'center', color: '#b00020' }}>
                      {error}
                    </td>
                  </tr>
                ) : rows && rows.length > 0 ? (
                  rows.map((row, idx) => (
                    <tr key={`ship-row-${idx}`}>
                      {columns.map((col) => (
                        <td
                          key={`${idx}-${col.id}`}
                          style={{
                            width: colWidthPct,
                            padding: '8px 12px',
                            borderBottom: '1px solid #eee',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                          title={safe(row, col.id)}
                        >
                          {safe(row, col.id)}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{ padding: '12px', textAlign: 'center', color: '#666' }}
                    >
                      No shipment data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Shipmentdetails
